import React from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import {
  Grid, Container, Header, Image, Icon, Button, Loader, Form
} from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { useProductsAndQuotation } from '../helpers/hooks';
import axios from 'axios';
import ExitIntentPopup from './ExitIntentPopup';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Continue = ({
  // history: { push },
  location: { pathname },
  match: { params },
}) => {
  const { t } = useTranslation();

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const { quotation, totals, products } = useProductsAndQuotation(params.id);

  const [step, setStep] = React.useState("default");
  const [coleta, setColeta] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(false);

  let query = useQuery();

  const formatCepHandleChange = (e) => {
    let cep = e.target.value;
    
    // Remove qualquer caractere que não seja número
    cep = cep.replace(/\D/g, '');
  
    // Aplica a máscara de CEP
    if (cep.length > 5) {
      cep = cep.slice(0, 5) + '-' + cep.slice(5, 8);
    }
  
    // Define o valor formatado no campo
    e.target.value = cep;
  };

  const formatCpfHandleChange = (e) => {
    let cpf = e.target.value;
  
    // Remove qualquer caractere que não seja número
    cpf = cpf.replace(/\D/g, '');
  
    // Aplica a máscara de CPF
    if (cpf.length > 3) {
      cpf = cpf.slice(0, 3) + '.' + cpf.slice(3);
    }
    if (cpf.length > 7) {
      cpf = cpf.slice(0, 7) + '.' + cpf.slice(7);
    }
    if (cpf.length > 11) {
      cpf = cpf.slice(0, 11) + '-' + cpf.slice(11, 14);
    }
  
    // Define o valor formatado no campo
    e.target.value = cpf;
  };

  const submitForm = (e) => {
    e.preventDefault();
    const allDataIsFilled = Array.from(e.target.querySelectorAll("input:not(.not-required),select")).every((field) => field.value !== '');

    if(!allDataIsFilled){
      alert('Por favor, preencha todos os campos para continuar.');
      return;
    }

    setIsSubmitting(true);

    const recieverMode = e.target.querySelector("#reciever_mode").value;
    const recieveLocation = e.target.querySelector("#recieve_location").value;
    const boxQuantity = e.target.querySelector("#box_quantity").value;

    let productsName='';

    products.valueSeq().toArray().map((product) =>{
      productsName += product.name + ',';
    });

    let paramsData = {
      quotation_id: params.id,
      recieve_value: recieverMode === 'D' ? totals.cash :  totals.credit,
      recieve_location: recieveLocation,
      products: productsName,
      box_quantity: (parseInt(boxQuantity) > 5 ? 5 : parseInt(boxQuantity)),
      user: {
        name: quotation.name,
        phone: quotation.phone_number,
        email: quotation.email
      },
    };

    e.target.querySelectorAll("input,select").forEach((item) => {
      paramsData.user[item.getAttribute('name')] = item.value;
    })
    // https://mgu-cwp.salescode.dev/correios/soap.php
    // https://cdn.salescode.dev/php/soap.php
    axios.post('https://mgu-cwp.salescode.dev/correios/soap.php', paramsData)
    .then((response) => {
      const { status, message, coleta, type } = response.data;


      if(status){
        document.querySelector(".ui.container.content.continue")?.classList.add("full-page");
        setStep("success");
        setColeta(coleta);

        return;
      }

      setStep("error");
      setErrorMessage(message);
    })
  };

  // switch(step){
  //   case "success":
  //     push(path.join(pathname, '/success'));
  //   break;
  //   case "error":
  //     push(path.join(pathname, '/error'));
  //   break;
  // }

  React.useEffect(() => {
    if (quotation?.shipping_number) {
      setStep("success");
      setColeta(quotation.shipping_number);
      document.querySelector(".ui.container.content.continue")?.classList.add("full-page");
    }
  }, [quotation]);

  return (
    <Grid centered>
      <Grid.Column>
        {step == "default" && !quotation?.shipping_number && (
        <>
          <Container textAlign="center">
            <Header as="h1" className="compact title-continue">
              {t("I'm glad you decided to move forward.")} 😎
            </Header>
            <Header as="h1" className="compact title-continue">
              {t('To finalize your sale and guarantee FREE SHIPPING, fill in the details below:')}
            </Header>
          </Container>

          <Container>
            <form className='ui form'
              onSubmit={submitForm}
            >

              <div className="field">
                <label htmlFor="cpf">CPF:</label>
                <div className="ui input">
                  <input id="cpf" name="cpf" type="text" onInput={formatCpfHandleChange} maxLength={14} />
                </div>
              </div>

              <div className="field">
                <label htmlFor="cep">CEP:</label>
                <div className="ui input">
                  <input id="cep" name="cep" type="text" onInput={formatCepHandleChange}/>
                </div>
              </div>

              <div className="field">
                <label htmlFor="address_number">Número da residência:</label>
                <div className="ui input">
                  <input id="address_number" name="address_number" type="number"/>
                </div>
              </div>

              <div className="field">
                <label htmlFor="address_complement">Complemento:</label>
                <div className="ui input">
                  <input id="address_complement" className='not-required' name="address_complement" type="text"/>
                </div>
              </div>

              <div className="field" style={{display: 'none'}}>
                <label htmlFor="reciever_mode">Como deseja receber?</label>
                <div className="ui input">
                  <select name='reciever_mode' id='reciever_mode'
                  readOnly
                  value={query.get('payment') === "pix" ? "D" : query.get('payment') === "credit" ? "C" : ""}
                  >
                    <option value="D">Dinheiro (PIX)</option>
                    <option value="C">Crédito em Loja</option>
                  </select>
                </div>
              </div>

              <div className="field">
                <label htmlFor="box_quantity">Quantidade de caixas</label>
                <div className="ui input">
                  <select name='box_quantity' id='box_quantity'>
                    <option value="1">1 Caixa</option>
                    <option value="2">2 Caixas</option>
                    <option value="3">3 Caixas</option>
                    <option value="4">4 Caixas</option>
                    <option value="5">5 Caixas</option>
                  </select>
                </div>
              </div>

              {query.get('payment') === "pix" && (
                <div className="field">
                  <label htmlFor="recieve_location">Insira sua chave pix:</label>
                  <div className="ui input">
                    <input id="recieve_location" name="recieve_location" type="text"/>
                  </div>
                </div>
              )}

              {query.get('payment') === "credit" && (
                <div className="field">
                <label htmlFor="recieve_location">Onde deseja receber esse valor?</label>
                <div className="ui input">
                  <select name='recieve_location' id='recieve_location'
                  >
                    <option value="SHOPB">SHOPB</option>
                    <option value="MEUGAMEUSADO">MEUGAMEUSADO</option>
                  </select>
                </div>
              </div>
              )}

              <Grid className="buttons-pair" columns={1} stackable>
                <Grid.Column textAlign="center">
                  <Button
                    id="next"
                    type="submit"
                    content={t('Next stage')}
                    primary
                    fluid
                    loading={isSubmitting}
                    disabled={isSubmitting}
                  />
                </Grid.Column>
              </Grid>
            </form>
          </Container>

          <Container textAlign="center">
          
          </Container>
          <ExitIntentPopup quotationID={params.id} />
        </>  
        )}

        {step == "success" && coleta && (
          <>
            <Header as="h1" className="compact title-continue">
              { t('Done! 🎉 Now just send us your package for FREE') }
            </Header>

            <Container textAlign="center">
              <div className="steps-cards">

                <div className="step card">
                  <h2>{t("Sending your products to us is very simple, just")}:</h2>
                  <p>
                    1- {t("Pack your items in any box, ensuring they are well protected for transport")}.
                    <br></br>
                    <br></br>
                    2- {t("Present the code below at any Post Office to guarantee free shipping through our contract with the Post Office")}:
                  </p>
                  {coleta.indexOf("[") > -1 && coleta.indexOf("]") > -1 ? 
                    JSON.parse(coleta).map((code, index) => (
                      <span className="code" key={index}>
                        {code}
                      </span>
                    ))
                  : (
                    <span className="code">{coleta}</span>
                  )}
                </div>

                <div className="step card">
                  <h2>{t("Keep an eye on your email")}</h2>
                  <p>
                    {t("You will receive a copy of this quote nº: #{{orderID}}, the POSTAGE AUTHORIZATION from the Post Office and you will be notified of the arrival of the products at our headquarters until payment", {orderID: quotation.id})}.
                    <br></br>
                    <br></br>
                    {t("In addition, we provide a contract that guarantees our commitment to all established terms")} <a href="https://www.meugameusado.com.br/pagina/contrato-de-vendas.html" target="_blank" rel="noreferrer">[{t("View Contract")}]</a>
                  </p>
                </div>

              </div>

              <div className="contact-helper">
                <h2>{t("Still have questions?")}</h2>
                <a href={`https://wa.me/5541987811674?text=Gostaria de tirar uma dúvida sobre a minha cotação numero `+params.id} target="_blank" rel="noreferrer"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M7.253 18.494l.724.423A7.953 7.953 0 0 0 12 20a8 8 0 1 0-8-8c0 1.436.377 2.813 1.084 4.024l.422.724-.653 2.401 2.4-.655zM2.004 22l1.352-4.968A9.954 9.954 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.004 22zM8.391 7.308c.134-.01.269-.01.403-.004.054.004.108.01.162.016.159.018.334.115.393.249.298.676.588 1.357.868 2.04.062.152.025.347-.093.537a4.38 4.38 0 0 1-.263.372c-.113.145-.356.411-.356.411s-.099.118-.061.265c.014.056.06.137.102.205l.059.095c.256.427.6.86 1.02 1.268.12.116.237.235.363.346.468.413.998.75 1.57 1l.005.002c.085.037.128.057.252.11.062.026.126.049.191.066a.35.35 0 0 0 .367-.13c.724-.877.79-.934.796-.934v.002a.482.482 0 0 1 .378-.127c.06.004.121.015.177.04.531.243 1.4.622 1.4.622l.582.261c.098.047.187.158.19.265.004.067.01.175-.013.373-.032.259-.11.57-.188.733a1.155 1.155 0 0 1-.21.302 2.378 2.378 0 0 1-.33.288 3.71 3.71 0 0 1-.125.09 5.024 5.024 0 0 1-.383.22 1.99 1.99 0 0 1-.833.23c-.185.01-.37.024-.556.014-.008 0-.568-.087-.568-.087a9.448 9.448 0 0 1-3.84-2.046c-.226-.199-.435-.413-.649-.626-.89-.885-1.562-1.84-1.97-2.742A3.47 3.47 0 0 1 6.9 9.62a2.729 2.729 0 0 1 .564-1.68c.073-.094.142-.192.261-.305.127-.12.207-.184.294-.228a.961.961 0 0 1 .371-.1z" fill="#ffffff"/></svg> {t("Contact us via WhatsApp")}</a>
              </div>
            </Container>
          </>
        )}

        {step == "error" && errorMessage && (
          <>
            <Header as="h1" className="compact title-continue">
              {errorMessage}
            </Header>
          </>
        )}
      </Grid.Column>
    </Grid>
  );
};

export default withRouter(Continue);
